import { render } from "./problem.vue?vue&type=template&id=dce41da0&scoped=true"
import script from "./problem.vue?vue&type=script&lang=js"
export * from "./problem.vue?vue&type=script&lang=js"

import "./problem.vue?vue&type=style&index=0&id=dce41da0&lang=less&scoped=true"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce41da0"]])

export default __exports__